import pantryActions from './pantry'
import displayActions from './display'

export default {displayActions, pantryActions};